import React, { createContext, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Orb } from "@/components/earnos/Orb";

const AssistantCtx = createContext({ open: () => {}, close: () => {} });
export const useAssistant = () => useContext(AssistantCtx);

// Every entry point uses the conversation workspace and its real work controls.
// Earlier assistant records remain stored on the server.
export function AssistantProvider({ children }) {
  const navigate = useNavigate();
  const open = useCallback(() => navigate("/chat"), [navigate]);
  const close = useCallback(() => {}, []);
  return <AssistantCtx.Provider value={{ open, close }}>{children}</AssistantCtx.Provider>;
}

export function AssistantFab() {
  const { open } = useAssistant();
  return (
    <button
      data-testid="assistant-fab"
      onClick={open}
      className="fixed bottom-24 lg:bottom-6 right-5 z-30 group"
      aria-label="Ask EARNOS"
    >
      <Orb state="idle" size={56} />
      <span className="absolute -bottom-0.5 -right-0.5 w-5.5 h-5.5 w-[22px] h-[22px] rounded-full bg-brand-violet border-2 border-surface flex items-center justify-center">
        <MessageCircle size={13} className="text-white" />
      </span>
    </button>
  );
}
